// xs 5
// sm 15
// md 21
// lg 9
// xl 10
export const Sizing = {
    xs: '24px',
    sm: '32px',
    md: '56px',
    lg: '64px',
    xl: '256px',
};
//# sourceMappingURL=Sizing.js.map